import styled, {css} from 'styled-components'

export const StyledDowngradePlanModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 50px 16px 0;
    height: 100%;
`

export const StyledAnimationContainer = styled.div`
    width: 180px;
    height: 180px;
    flex-shrink: 0;
    margin-bottom: 50px;
`
export const StyledInformContainer = styled.div`
    ${() => css`
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;
        flex: 1;
    `}
`
export const StyledInformTitle = styled.h3`
    ${() => css`
        color: #00063d;
        text-align: center;
        font-family: Inter;
        font-size: 22px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -1.1px;
    `}
`
export const StyledInformDescription = styled.p`
    ${() => css`
        color: #000;
        text-align: center;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%; /* 19.6px */
        opacity: 0.5;
    `}
`
export const StyledButtonsContainer = styled.div`
    ${() => css`
        padding: 30px 0;
        display: flex;
        flex-direction: column;
        border-top: 1px solid rgb(0 0 0 / 10%);
        width: 100%;
        gap: 20px;
    `}
`
